import { DefaultInMemoryPagingOfferConfiguration } from './DefaultInMemoryPagingOfferConfiguration';
import { ILivePageableOfferConfiguration } from "./ILivePageableOfferConfiguration";

export class DefaultPrematchPageableConfiguration extends DefaultInMemoryPagingOfferConfiguration implements ILivePageableOfferConfiguration {
}